var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from "moment";
import FetchService from "./Shared/FetchService";
import { getApiClient } from "../../services/AxiosClients";
const advisorURL = "/aviso/advisor";
const academicCalendarURL = "/aviso/academicCalendar";
export default class AcademicCalendarService {
    static getTermsList() {
        return FetchService.getSingleResponse(advisorURL + "/terms");
    }
    static getTerm(affiliationId, academicCalendarId, transcriptCourseStatusId) {
        return FetchService.get(advisorURL + "/getTerm", {
            affiliationId,
            academicCalendarId,
            transcriptCourseStatusId,
        });
    }
    static getFacultyCourses(term) {
        return FetchService.getSingleResponse(advisorURL + "/courseSections", {
            term,
        });
    }
    static getClosestTermForFaculty() {
        return FetchService.getSingleResponse(advisorURL + "/getClosestTermForAffiliation");
    }
    static getTermsById(ids) {
        return FetchService.get(academicCalendarURL + "/getTermsById", { ids });
    }
    static getTermsByIdIncludeCurrent(ids) {
        if (ids.includes("0")) {
            return FetchService.get(academicCalendarURL + "/getTermsById", {
                ids,
            }).then((data) => [
                { name: "Current Term", id: 0 },
                ...data,
            ]);
        }
        return FetchService.get(academicCalendarURL + "/getTermsById", { ids });
    }
    static getAcademicCalendars(search) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("academicCalendars/search/findByDisplayNameContainsIgnoreCase", {
                params: { search, sort: "displayName", order: "ASC", size: 30 },
            });
            return response.data._embedded.academicCalendars;
        });
    }
    static findByIds(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("academicCalendars/search/findByIdIn", { params: { ids: ids.join(",") } });
            return response.data._embedded.academicCalendars;
        });
    }
    static search(query, max) {
        return FetchService.getSingleResponse(academicCalendarURL + "/list", {
            searchText: query,
            max,
        });
    }
    static lookupSearch(search, options = {}) {
        return FetchService.getPagedResponse(academicCalendarURL + "/search", {
            ids: search.ids,
            names: search.names,
            startDateTo: search.startDateTo,
            startDateFrom: search.startDateFrom,
            endDateTo: search.endDateTo,
            endDateFrom: search.endDateFrom,
            max: options.max,
            sort: options.sort,
            offset: options.offset,
            order: options.order,
        });
    }
    static searchFutureTerms(query, max) {
        return FetchService.getSingleResponse(academicCalendarURL + "/search", {
            names: query,
            startDateFrom: moment(Date.now()),
            max,
        });
    }
    static findAllById(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            // fetch the specific terms from the API
            const apiClient = getApiClient();
            const response = yield apiClient.get(`/academicCalendars/search/findByIdIn?ids=${ids.join(",")}`);
            return response.data._embedded.academicCalendars;
        });
    }
}
